<template>
  <el-form inline :model="value" class="header-bar">
    <el-form-item label="日期范围">
      <el-date-picker type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" v-model="dateRange" value-format="yyyy-MM-dd" :picker-options="pickerOptions">
      </el-date-picker>
    </el-form-item>
    <el-form-item label="选择班组">
      <el-select v-model="value.teamNos" placeholder="请选择">
        <el-option v-for=" item in $store.getters.commonDict['base_team_type']" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="员工姓名">
      <el-select v-model="value.leaderIds" placeholder="请选择">
        <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="handleQuery">查询</el-button>
      <el-button @click="handleReset">重置</el-button>
      <!-- <el-button type="text">导出数据</el-button> -->
    </el-form-item>
  </el-form>
</template>
 <!-- startTime; endTime -->
<script>
import { getUserList } from "@/views/dispatch-manage/check-plan-list/api.js";
import { getDefaultSearchTimeRange, getSearchTimePickerOptions } from "@/basic-common/util/common";

export default {
  data () {
    return {
      userList: [],
      dateRange: getDefaultSearchTimeRange('daterange'),
      pickerOptions: getSearchTimePickerOptions('daterange'),
      leaderIds: ''
    }
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  created () {
    this.init()
    this.syncDateRange()
  },
  methods: {
    syncDateRange () {
      if (this.dateRange.length) {
        this.$set(this.value, 'startTime', this.dateRange[0])
        this.$set(this.value, 'endTime', this.dateRange[1])
      }
    },
    handleQuery () {
      this.syncDateRange()
      this.$emit('handleQuery')
    },
    handleReset () {
      this.$set(this.value, 'leaderIds','')
      this.$set(this.value, 'teamNos','')
      this.dateRange = getDefaultSearchTimeRange('daterange')
      this.syncDateRange()
      this.$emit('handleQuery')
    },
    init () {
      getUserList().then(({ data }) => {
        this.userList = data
      })
    }
  }
}
</script>

<style scoped>
.header-bar {
  margin-bottom: 20px;
}
</style>
